/**
 * The seat this browser holds in a room.
 *
 * A session token is what gets you back into your own seat after a refresh, a
 * closed laptop or a server restart. It is kept per room, because one browser
 * can be in more than one, and it is the only thing about a game this client
 * stores — there are no accounts, and possession of the token is the claim.
 *
 * Storage can throw (a private window, blocked site data), and a token that
 * cannot be read is only a lost seat, not a broken page — so every access is
 * guarded and failure is simply "no token".
 */
const KEY = (roomCode: string) => `trajan:seat:${roomCode}`;

export function rememberSeat(roomCode: string, sessionToken: string): void {
  try {
    localStorage.setItem(KEY(roomCode), sessionToken);
  } catch {
    // Not being able to remember costs a seat on refresh, nothing more.
  }
}

export function seatToken(roomCode: string): string | null {
  try {
    return localStorage.getItem(KEY(roomCode));
  } catch {
    return null;
  }
}

export function forgetSeat(roomCode: string): void {
  try {
    localStorage.removeItem(KEY(roomCode));
  } catch {
    /* nothing to undo */
  }
}
